import { render, staticRenderFns } from "./RecentReviews.vue?vue&type=template&id=62be09b5&scoped=true&"
import script from "./RecentReviews.vue?vue&type=script&lang=js&"
export * from "./RecentReviews.vue?vue&type=script&lang=js&"
import style0 from "./RecentReviews.vue?vue&type=style&index=0&id=62be09b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be09b5",
  null
  
)

export default component.exports